import { render, staticRenderFns } from "./FormStatusCommand.vue?vue&type=template&id=96d08c22"
import script from "./FormStatusCommand.vue?vue&type=script&lang=js"
export * from "./FormStatusCommand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports